export default "__VITE_ASSET__BT18Ju45__"